import { isStringEmpty } from './objectUtils';
import ROUTES from '../constants/routes';

// the launcher shows on contact us and the patient dashboard only; funnels, checkout, marketing and admin
// pages all hide it
const LAUNCHER_ROUTES = [
	ROUTES.CONTACT,
	ROUTES.ACCOUNT,
	ROUTES.PAY_NOW,
	ROUTES.SUBSCRIPTION_CANCEL,
	ROUTES.SUBSCRIPTION_CHANGE,
	ROUTES.SUBSCRIPTION_MEDICATION_CHANGE
];

// dashboard pages that still hide it
const DASHBOARD_HIDDEN_LAUNCHER_ROUTES = [ROUTES.MY_MESSAGES, ROUTES.SUBSCRIPTION_REACTIVATION];

const isUnderRoute = (pathname: string, route: string): boolean => pathname === route || pathname.startsWith(route + '/');

// single source of truth for launcher visibility, shared by the Intercom boot in AppWrapper, the
// route-change update in WrapperLayout, and the overlay-close restore in useHideIntercomLauncher
// so the three can never drift.
export const shouldHideIntercomLauncher = (pathname: string): boolean => {
	if (isStringEmpty(pathname)) {
		return true;
	}

	if (DASHBOARD_HIDDEN_LAUNCHER_ROUTES.some((route) => isUnderRoute(pathname, route))) {
		return true;
	}

	// the dashboard home renders at the root, so it is matched exactly rather than as a prefix
	const isLauncherRoute = pathname === ROUTES.LANDING || LAUNCHER_ROUTES.some((route) => isUnderRoute(pathname, route));

	return isLauncherRoute === false;
};
